<template>
  <div class=" o_list">    
    <van-nav-bar
      class="bar"
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="500"
            @load="onLoad"
          >
            <van-cell
              v-for="item in list"
              :key="item.order_id"
            >
              <div class="shop">
                <div class="head">
                  <div class="name">{{item.store_name}}</div>
                  
                  
                </div>
                <div
                  class="body"
                >
                  <ul>
                    <li
                      class="clearfix"
                      v-for="(v,i) in item.goods"
                      :key="i"
                    >
                      <img
                        :src="v.sku_thumb"
                        alt=""
                      >
                      <div class="conten">
                        <p class="title">{{v.name}}</p>
                        <div class="price">￥{{v.goods_price}}</div>
                        <div class="num">x{{v.goods_num}}</div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="foot">
                  <!-- <div class="bei">备注：<span>{{item.remark}}</span></div> -->
                  <div class="statistics clearfix">
                    <div class="money fr">实际付款：<span>￥{{item.actual_money}}</span></div>
                    <div class="number fr">共计{{item.goods.length}}件商品</div>
                  </div>
                  <div class="but">
                    <button
                     
                      class="red"
                      @click="ash(item,0)"
                    >整单退货</button>
                      <button
                     
                      class="orange"
                      @click="delet(item,1)"
                    >部分退货</button>
                    
                    
                    <!-- <button
                      v-show=" item.order_status=='已取消'"
                      :class="[states?'red':'orange']"
                      @click="aging(item)"
                    >再次购买</button> -->
                    
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>

        </div>
   <van-popup
      v-model="show"
      position="bottom"
      style="height: 80%; padding-top: 4px;"
    >
  
    <div class="bt">
    <van-checkbox-group v-model="result">
  <van-checkbox v-for="v in results" :key="v.order_goods_id" :name="v">
    <div class="ju">
     <img
                        :src="v.sku_thumb"
                        alt=""
                      >
                      <div class="conten">
                        <p class="title">{{v.name}}</p>
                        <div class="price">￥{{v.goods_price}}</div>
                        <div class="num">x{{v.goods_num}}</div>
                      </div>
                      </div>
                     
  </van-checkbox>
  
</van-checkbox-group>
   </div>
      <div class="but3">
                      <van-button @click="got" type="danger" size="large">确认</van-button>

      </div>
     
    </van-popup>
   </div>  
</template>
<script>
import Vue from 'vue'
// import List from './child/list'
import { NavBar, Tab, Tabs, List, Cell, Search, Dialog, Toast, CountDown,Popup, Checkbox, CheckboxGroup,Button } from 'vant'

Vue.use(NavBar).use(Tabs).use(Tab).use(Cell).use(List).use(Search).use(Dialog).use(CountDown).use(Popup).use( Checkbox).use(CheckboxGroup).use(Button)
export default {
  created () {

  },
  mounted () {
    // this.deng()
    window.addEventListener('scroll', this.windowScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.windowScroll)


  },

  data () {
    return {
      value: '',
      title: '订单列表',
      nav: ['未结算', '已提交', '待发货', '发货中','已完成','已取消'],
      active: 1,
      states: true,
      list: [],
      loading: false,
      finished: false,
      page: 1,
      show:false,
      result:[],
      results:[],
    }
  },
  methods: {
    aging (i) {
      console.log(i)
      return false
      this.axios.post('addcart', {
          // i.goods
        })
        .then((res) => {
          if (res.data.code == 1004) {
            localStorage.setItem(
              'token',
              JSON.stringify({ id: res.data.token })
            )
            this.gocar()
          }
          Toast(res.data.msg)
        })
        .catch((ref) => { })
      // this.$router.push('car')
    },
    deng () {


      // console.log(this.active)
      this.axios.post('orderList', { type: 1 , page: this.page }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.deng()
        }
        // console.log(Date.parse(new Date()))
        if (res.data.code == 200) {
          res.data.data.forEach(v => {
            // console.log(Date.parse(new Date()) - v.create_time)
           
            if(v.money){

            }else{
              v.money=0
            }
            // v.goods.forEach(a => {
            //   a.goods_price = Number(a.goods_price).toFixed(2)
            // })
            // console.log(v)
            this.list.push(v)
          })


        } else {
          this.page = 0
        }
        this.loading = false;
        this.finished = true;
        // console.log(this.list)
        // this.nouse = res.data.data
      }).catch(ref => { })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    search () {
      if (this.value == "") {
        return
      }
      // console.log(this.value)
    },
    change (name) {
      this.list = []
      this.page = 1
      this.onLoad(name)
    },
    onLoad (v) {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.deng()
    },
    getScrollTop () {
      var scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
    // 获取当前可视范围的高度
    getClientHeight () {
      var clientHeight = 0
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
      }
      return clientHeight
    },

    // 获取文档完整的高度
    getScrollHeight () {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
    },
    windowScroll () {
      if (this.page == 0) {
        return false
      }
      if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 0) {
        // if (this.status === 1) {
        //   this.status = 0
        //   // 页码，分页用，默认第一页
        //   // this.deliverParams.page += 1
        //   // 调用请求函数
        //   alert('触发！！！')
        // }
        this.page++
        this.deng()
      }
    },
    goo(v){
      this.$router.push({ name: 'xiu', params: { id: v, i: 3 } })
    },
    go (v) {
     
    },
    got(){
      console.log(this.result)
      if(this.result.length==0){
        Toast('请选择要退商品')
        return
      }
      if(this.$store.state.tgood.length==0){
      this.$store.state.tgood.push({goods:this.result,id:this.result[0].id})
     this.$router.go(-1)

return
      }
      let adrr=[]
      let  zh=''
      this.$store.state.tgood.forEach(v=>{
        v.goods.forEach(v1=>{
        adrr.push(v1.order_goods_id)
          zh=v1.zheng
        })
      })
      if(zh==1){
        Toast('已选择整单退货，无法添加新商品')
        return
      }
      let flag = []
      this.result.forEach(v2=>{
        if(adrr.indexOf(v2.order_goods_id)!=-1){
            Toast(v2.name+'已添加')
            flag.push(1)
            return false
          }else{
            
     
          }
      })
      if(flag.indexOf(1)!=-1){

      }else{
this.$store.state.tgood.push({goods:this.result,id:this.result[0].id})
     this.$router.go(-1)
      }
 
    //   this.$store.state.tgood.push({goods:this.result,id:this.result[0].id})
    //  this.$router.go(-1)

    },
    godetails (v, i) {
      this.$router.push({ name: 'details', params: { id: v, i } })
    },
    ash (v,i) {
     console.log(v)
     v.goods.forEach(s=>{
        s.max=s.goods_num
        s.id=v.id
        s.txt=''
        s.zheng=1
        s.order_id=v.order_id
     })
     if(this.$store.state.tgood.length==0){ 
    this.$store.state.tgood.push(v)
     this.$router.go(-1)
return false
     }else{
      Toast('已选择过订单')
      return false
        let arr=[]
this.$store.state.tgood.forEach(a=>{
    arr.push(a.id)
})
       if(arr.indexOf(v.id)!=-1){
        Toast('此单已添加过商品')
       }else{
    this.$store.state.tgood.push(v)
     this.$router.go(-1)

       }
     }
     
     
    },
    delet (v) {
      let ban=0
      this.$store.state.tgood.forEach(v1=>{
        v1.goods.forEach(v2=>{
       ban=v2.order_id
      })
      })
     console.log(ban)

      if(ban==0){

      }else{
if(v.order_id!=ban){
        Toast('请单个订单依次退货')
        return
      }
      }
      
      this.result=[]

v.goods.forEach(s=>{
        s.max=s.goods_num
        s.id=v.id
        s.txt=''
        s.zheng=0
        s.order_id=v.order_id
     })
     this.results=v.goods
     this.show=true
    }
  },
  components: {
    // List
  }
}
</script>
<style lang="less" scoped>
.sear {
  height: 1rem;
  .van-search {
    height: 1rem;
  }
}
.o_list {
  padding-top: 1.2rem;
  .bar {
    z-index: 99;
  }
}
.cs {
  text-align: center;
  color: red;
}
.tab {
  padding: 0.3rem 0;
  background-color: #f7f7f7;
}
.list {
  background-color: #f7f7f7;
}
.van-cell {
  margin: 0.3rem 0;
}
.shop {
  background-color: #fff;
  // padding: 0 0.3rem;
  .head {
    display: flex;
    height: 1rem;
    line-height: 1rem;
    justify-content: space-between;
    .name {
      font-size: 0.4rem;
    }
    .time {
      padding-top: 0.15rem;
      color: #a22d2b;
    }
    .state {
      font-size: 0.4rem;
      color: #a22d2b;
    }
  }
  .body {
    background-color: #fff;
    border-top: 1px solid #efefef;
    .dianj {
      text-align: center;
    }
    li {
      border-bottom: 1px solid #efefef;
      padding: 0.3rem 0;
      position: relative;

      img {
        width: 2.4rem;
        height: 2.4rem;
        float: left;
      }
      .conten {
        padding-left: 2.8rem;
        // position: absolute;
        .title {
          width: 80%;
          color: #333;
          line-height: 0.36rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .type {
          width: 90%;
          color: #888;
          padding-top: 0.2rem;
        }
        .price {
          padding-top: 0.5rem;
          font-weight: 700;
          font-size: 0.45rem;
        }
        .num {
          position: absolute;
          right: 5%;
          color: #888;
          top: 2%;
        }
      }
    }
  }
  .foot {
    .bei {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    background-color: #fff;
    .statistics {
      padding: 0.2rem;
      padding-top: 0;
      .money {
        padding-left: 0.3rem;
        font-size: 0.4rem;
        color: #333;
        span {
          font-size: 0.453333rem;
        }
      }
      .number {
        font-size: 0.4rem;
        color: #333;
      }
    }
    .bf{
      position: relative;
    }

    .but {
      text-align: right;
      padding: 0.2rem 0 0.5rem 0;
      button {
        width: 2rem;
        height: 0.8rem;
        background: #fff;

        border-radius: 5px;
        outline: none;
        margin-left: 0.2rem;
      }
      .ash {
        border: 1px solid #b0b0b0;
        color: #b0b0b0;
      }
      .red {
        border: 1px solid #a22d2b;
        color: #a22d2b;
      }
      .orange {
        border: 1px solid #f97817;
        color: #f97817;
      }
    }
  }
}
    .but3{
      width: 100%;
position: fixed;
bottom: 0;
    }
    .bt{
padding-left: 0.3rem;
padding-bottom: 1rem;

    }
.ju{
   border-bottom: 1px solid #efefef;
      padding: 0.3rem ;
      position: relative;
      img {
        width: 2.4rem;
        height: 2.4rem;
        float: left;
      }
      .conten {
        padding-left: 2.8rem;
        // position: absolute;
        height: 2.5rem;
        .title {
          width: 80%;
          color: #333;
          line-height: 0.36rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .type {
          width: 90%;
          color: #888;
          padding-top: 0.2rem;
        }
        .price {
          padding-top: 0.5rem;
          font-weight: 700;
          font-size: 0.45rem;
        }
        .num {
          position: absolute;
          right: 5%;
          color: #888;
          top: 2%;
        }
      }
}
</style>
